<template>
  <BaseCard
    class="flex items-center gap-1.5 p-3 lg:gap-3.5 lg:p-4"
    :class="{
      'border-danger!': props.showWarning,
    }"
  >
    <BaseIcon
      :name="icon"
      filled
      class="shrink-0 text-xl lg:text-2xl"
      :class="
        props.showWarning ? 'fill-danger opacity-90' : fillMap[props.iconColor]
      "
    />
    <div class="flex flex-col">
      <p class="text-base font-bold lg:text-xl">{{ displayValue }}</p>
      <TextDescription class="text-sm whitespace-nowrap lg:text-base">
        <slot name="description" :label>
          {{ label }}
        </slot>
      </TextDescription>
    </div>
  </BaseCard>
</template>

<script setup>
import { computed } from "vue"
import { formatNumber, formatUnit } from "@/helpers/formatter.js"
import {
  BaseCard,
  BaseIcon,
  TextDescription,
} from "@repowerednl/ui-component-library"

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  value: {
    type: Number,
    default: NaN,
  },
  unit: {
    type: [String, Boolean],
    default: false,
  },
  icon: {
    type: String,
    required: true,
  },
  iconColor: {
    type: String,
    default: "primary",
  },
  format: {
    type: String,
    default: "",
  },
  precision: {
    type: Number,
    default: 0,
  },
  showWarning: {
    type: Boolean,
    default: false,
  },
})

const displayValue = computed(() => {
  if (!Number.isFinite(props.value)) {
    return "-"
  }
  let valueString
  if (props.unit !== false) {
    valueString = formatUnit(props.value, props.unit, props.precision)
  } else {
    valueString = formatNumber(props.value, props.precision)
  }
  return props.format ? props.format.replace("_", valueString) : valueString
})

const fillMap = {
  energy: "fill-energy",
  finance: "fill-finance",
  primary: "fill-primary",
  danger: "fill-danger",
  info: "fill-info",
  success: "fill-success",
}
</script>
